import { Modalable, ResponseStatus } from './modalable';

export class Modal implements Modalable {

    status: ResponseStatus;
    private id: string;
    private open: boolean;
    private options: any;
    private animation: string;
    private bypassCheck: boolean;

    constructor(id: string, options: any, animation?: string) {
        this.id = id;
        this.setOptions(options);
        this.open = false;
        this.bypassCheck = true;
        if (animation) {
            this.animation = animation;
        }
    }

    getStatus(): ResponseStatus {
        return this.status;
    }

    getId(): string {
        return this.id;
    }

    setOpen(open: boolean): void {
        this.open = open;
    }

    isOpen(): boolean {
        return this.open;
    }

    getOptions(): any {
        return this.options;
    }

    setOptions(value: any): void {
        this.options = value;
    }

    getAnimation(): string {
        return this.animation;
    }

    getModalId(): string {
        return this.id;
    }

    canBypassCheck(): boolean {
        return this.bypassCheck;
    }
}
